'use strict';

import query from './query';
import core from './core';
import settings from './settings';

export default {
  query,
  core,
  settings,
};
